
$(document).ready(function() {  
  const IMAGESPATH = '/wp-content/themes/new-ces/img/marcas/';
  function getLogoBrand(brand_name) {
    brand_name = brand_name.replace(/\s/g,'-');
    brand_name = brand_name.toLowerCase();
    return IMAGESPATH + brand_name + '-color.png';
  }
  let allPosts = []
  let countCards = 0

  function loadPosts( typePost, containerResults, pageNumber = null ) {
    switch (typePost) {
      case "new":
        var action = "more_post_ajax";
        var template = wp.template( 'car-card' );
        break;
      case "used":
        var action = "more_post_used_ajax";
        var template = wp.template( 'used-car-card' );
        break;
      case "machinery":
        var action = "more_post_machinery_ajax";
        var template = wp.template( 'machinery-card' );
        break;
    }

    /**Get params of filter */
    const params = ajax_filter_params.query_params;
    params.car_class   = (params.car_class == 'todos') ? '' : params.car_class;
    params.car_model_slug   = (params.car_model_slug == 'todos') ? '' : params.car_model_slug;
    params.car_combustible   = (params.car_combustible == 'todos') ? '' : params.car_combustible;
    params.car_transmision   = (params.car_transmision == 'todos') ? '' : params.car_transmision;
    params._ceswp_transmission   = (params._ceswp_transmission == 'todos') ? 'todos' : params._ceswp_transmission;
    /**distintos casos para reparar var params.brand_name*/
    if(params.brand_name == 'todos'){
      params.brand_name = '';
    }else if(params.brand_name.search('\\+') != -1){
      params.brand_name = params.brand_name;
    }

    $('#loading').show();

    if (searchPosts) {
      $.ajax({
        type: 'GET',
        url: ajax_filter_params.ajax_url,
        dataType: 'json',
        data: {
          pageNumber:         pageNumber,
          car_class:          params.car_class,
          brand_name:         params.brand_name,
          car_model_slug:     params.car_model_slug,
          price_min:          params.price_min,
          price_max:          params.price_max,                
          featured:           params.featured,                
          car_year:           params.car_year,
          special_sale:       params.special_sale,
          ids:                params.ids,
          car_combustible:    params.car_combustible,
          car_transmision:    params.car_transmision,
          _ceswp_transmission:   params._ceswp_transmission,
          car_order:          params.car_order,
          action:             action
        },
        success: function (data) {
          if (data.posts.length && Array.isArray(data.posts)) {
            $('#number_posts').html(data.found_posts);
            $('#number_posts_filter').html(data.found_posts);
            if (typePost !== 'new') {
              $('.cont-search-used').removeClass('d-none');
              sortedBy(true)
            } else {
              $('.cont-search').removeClass('d-none');
            }

            allPosts = data.posts            
            printResults(allPosts, containerResults, template, typePost, data.found_posts, false)

            $('#loading').hide();
          } else {
            $('#loading').hide();
          }
        },
        error: function (jqXHR, textStatus, errorThrown) {
          $('#loading h5').html('No se encontraron resultados.');
          $('#loading img').removeClass('d-block').addClass('d-none');
          $('#loading').hide();
          console.log(textStatus)
        }
      })
    }
    return false
  }

  /**Container page-search-news*/
  let loadingInfiniteScroll = false
  if($("#posts").length){
    var searchPosts = true
    loadPosts('new',$("#posts"));
    
    const offset = window.innerWidth < 475 ? 1077 : 300
    window.onscroll = () => {
      let bottomOfWindow =
        document.documentElement.scrollTop + window.innerHeight >=
        document.documentElement.offsetHeight - offset

      if (bottomOfWindow) {
        if (!loadingInfiniteScroll) {
          loadingInfiniteScroll = false
          printResults(allPosts, $("#posts"), wp.template( 'car-card' ), 'new', allPosts.length, true) 
          loadingInfiniteScroll = true   
        }
      }
    }
  }

  /**Container page-search-used*/
  if($("#used-cars").length) {
    var searchPosts = true
    var page_number  = 1
    loadPosts('used', $("#used-cars"), page_number)
    
    let loadingInfiniteScroll = false
    const offset = window.innerWidth < 475 ? 1077 : 300
    window.onscroll = () => {
      let bottomOfWindow =
        document.documentElement.scrollTop + window.innerHeight >=
        document.documentElement.offsetHeight - offset

      if (bottomOfWindow) {
        if (!loadingInfiniteScroll) {
          loadingInfiniteScroll = true
          page_number++
          loadPosts('used', $("#used-cars"), page_number)
        }
      }
    }
  }

  /**Order of post used */
  function sortedBy(asc){
    $divs   = $('.grid-item');
    var numericallyOrderedDivs = $divs.sort(function (a, b) {
      var vA = $(a).find('.item-used-card').data('price');
      var vB = $(b).find('.item-used-card').data('price');
      return ((vA < vB) ? -1 : (vA > vB) ? 1 : 0) * (asc ? -1 : 1);
    });
    var postDiv = $("#used-cars");
    postDiv.html(numericallyOrderedDivs);
  }

  /**Button order in used */
  $('.order-grid').on( 'click', function(e) {
    var asc = $(this).hasClass('asc');
    sortedBy(asc);

    $(this).addClass('active');

    $('.order-grid').not(this).each(function(){
        $(this).removeClass('active');
    });
  });

  /**Function printResults */
  function printResults(posts, containerResults, template, typePost, totalPosts = 0, load) {
    if ( typePost === 'new' ) {
      let arrayData = []
      if (load) {
        let arrayMoreVersions = posts.slice(9, allPosts.length)
        arrayData = arrayData.concat(arrayMoreVersions)
      }else{
        let arrayVersions = posts.slice(0, 9)
        arrayData = arrayData.concat(arrayVersions); 
        //console.log(arrayData)
      }

      arrayData.forEach( function(post_meta){
        post_meta._ceswp_brand_img                    = (post_meta._ceswp_brand_name) ? getLogoBrand(post_meta._ceswp_brand_name) : '/wp-content/themes/new-ces/img/loading.svg';
        post_meta._ceswp_public_price                 = post_meta._ceswp_price_min || 'Sin información';
        post_meta._ceswp_price_bonus_amicar_render    = post_meta._ceswp_price_bonus_brand - post_meta._ceswp_price_amicar;
        post_meta._ceswp_price_bonus_brand_render     = post_meta._ceswp_price_list - post_meta._ceswp_price_bonus_brand;
    
        render = template( post_meta );
        containerResults.append('<div class="col-12 col-md-6 col-lg-4 grid-item">' + render + '</div>');
        Waypoint.refreshAll();
      });
    
      /**Button compare */
      containerResults.find(".compare-from-card").each(function () {
        this.onclick = function () {
          this.disabled = true
          toggleCarFromComparator(this.dataset.id)
        }
      })
      containerResults.find(".button-compare").each(function () {
        this.onclick = function () {
          goToComparator()
        }
      });
      // Updates the comparator button status (comparator.js)
      if (typeof updateComponents === "function") {
        containerResults.find(".compare-from-card").each(function () {
          this.onclick = function () {
            this.disabled = true
            toggleCarFromComparator(this.dataset.id)
          }
        })
        updateComponents();
      }

      //Count Posts for cards
      let containerPost = document.querySelector('#posts');
      let cards = containerPost.querySelectorAll('.grid-item');
      countCards = cards.length; 
    } else { /**Autos usados */
      posts.forEach( function(post_meta){
        post_meta._ceswp_brand_img                    = (post_meta._ceswp_brand_name) ? getLogoBrand(post_meta._ceswp_brand_name) : '/wp-content/themes/new-ces/img/loading.svg';
        post_meta._ceswp_public_price                 = post_meta._ceswp_price_min || 'Sin información';
        post_meta._ceswp_price_bonus_amicar_render    = post_meta._ceswp_price_bonus_brand - post_meta._ceswp_price_amicar;
        post_meta._ceswp_price_bonus_brand_render     = post_meta._ceswp_price_list - post_meta._ceswp_price_bonus_brand;
    
        render = template( post_meta );
        containerResults.append('<div class="col-12 col-md-6 col-lg-4 grid-item">' + render + '</div>');
        Waypoint.refreshAll();
      });
    }    
  }

  

  /**Function infinite scroll loadPosts */
  /* scroll(9, null)
  function scroll( versionsToShow, filteredVersions ) {
    
  } */

  /* let loadingInfiniteScroll = false
  const offset = window.innerWidth < 475 ? 1077 : 300
  window.onscroll = () => {
    let bottomOfWindow =
      document.documentElement.scrollTop + window.innerHeight >=
      document.documentElement.offsetHeight - offset

    if (bottomOfWindow) {
      if (!loadingInfiniteScroll) {
        loadingInfiniteScroll = true          
        loadMorePosts( 9, filteredVersions )
      }
    }
  } */

  /**Function loadMorePosts */
  /* function loadMorePosts( versionsToShow, filteredVersions null ) {
    let versionsToShowNewValue = versionsToShow + 9
    if (versionsToShowNewValue < filteredVersions.length) {
      versionsToShow = versionsToShowNewValue
    } else {
      versionsToShow = filteredVersions.length
    }
    loadingInfiniteScroll = false
  } */
});
